<template>
    <div class="default-view">
        <h1>Dental Clinic</h1>
        <p>Fecha: {{ currentDate }}</p>
        <p>App Version: {{ appVersion }}</p>
    </div>
</template>

<script>
export default {
    name: 'DefaultView',
    data() {
        return {
            currentDate: new Date().toLocaleDateString(),
            appVersion: '1.0.14'
        }
    }
}
</script>

<style scoped>
.default-view {
    padding: 20px;
    text-align: center;
}
</style>
